var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Analytics } from '../../../helpers/analyticsMiddleware';
import { useEffect } from 'react';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import FAQRow from './FAQRow';
import { TableContainer } from './subcomponents';
var FAQTable = function (_a) {
    var faqs = _a.faqs;
    useEffect(function () {
        triggerAnalyticsEvent({
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Billing,
            pageSubFunction: Analytics.Documents,
            pageName: Analytics.FAQs
        });
        return function () {
            triggerAnalyticsEvent({
                pageKind: Analytics.Activity,
                pageFunction: Analytics.DisputeTransaction,
                pageSubFunction: '',
                pageName: Analytics.View
            });
        };
    }, []);
    return (_jsx(TableContainer, __assign({ "data-cy": "faq-table" }, { children: faqs.map(function (faq) {
            return (_jsx(FAQRow, { questionHeader: faq.questionHeader, answerBody: faq.answerBody }, faq.id));
        }) })));
};
export default FAQTable;
//# sourceMappingURL=index.js.map